export default "__VITE_ASSET__B8Bt$5kg__"